import type { IntlShape } from 'react-intl';

import type { BreadcrumbItem } from '@/components/Breadcrumb';
import { paths } from '@/lib/paths';
import { commonMessages } from '@/messages/common';

export const getWatchPdpBreadcrumbs = (
  formatMessage: IntlShape['formatMessage'],
  collectionName: string,
  collectionSlug: string,
  watchName?: string,
): BreadcrumbItem[] => {
  const getCollectionTarget = (): string => {
    if (!watchName) {
      return paths.watches.collection.asPath({ slug: collectionSlug });
    }

    switch (true) {
      case watchName.includes('NFL'):
        return paths.watches.nfl.asPath();
      default:
        return paths.watches.collection.asPath({ slug: collectionSlug });
    }
  };

  const getCollectionLabel = (): string => {
    if (!watchName) {
      return collectionName;
    }

    switch (true) {
      case watchName.includes('NFL'):
        return 'NFL';
      default:
        return collectionName;
    }
  };

  return [
    { label: formatMessage(commonMessages.home), target: paths.url() },
    {
      label: formatMessage(commonMessages.watches),
      target: paths.watches.url(),
    },
    {
      label: getCollectionLabel(),
      target: getCollectionTarget(),
    },
  ];
};
